import { push, ref, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetSaleReturnDataFirebase from "../../SaleReturn/GetSaleReturnDataFirebase";
import AddItemDataInFirebase from "../Items/AddAssignerUserItemDataInFirebase";

const AddAssignerUserSaleReturnDataInFirebase = async (state, dispatch, invoiceData, userId, ownerUid) => {
    if (!ownerUid) return null;
    try {

        const formatItems = (rawItems) => {
            return rawItems.map(i => ({
                // amount: i?.amount?.toString() || "0.00",
                // billId: invoiceData?.id?.toString() || "",
                // companyId: invoiceData?.companyId?.toString() || "",
                // creationDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
                // isSalesReturnKey: "",
                // itemId: "",
                // name: i?.name || "",
                // price: i?.price?.toString() || "",
                // quantity: ,
                // subtitle: i?.subtitle || "",
                // updateDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString()
                itemId: i?.itemId?.toString() || "",
                itemAddedDate: new Date().getTime().toString() || "",
                price: i?.price?.toString() || "",
                quantity: i?.quantity?.toString() || "",
                // name: i?.name || "",
            }));
        };

        // Reference to user's invoice data
        const userRef = ref(database, `invoiceGenerator/users/${ownerUid}/returnInvoice`);

        // Push new invoice data
        await push(userRef, {
            createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            createdById: state?.USERID || null,
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            updatedById: state?.USERID || null,
            // discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            // discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            // dueDate: invoiceData?.dateDue?.toString() || new Date().getTime().toString(),
            // email: invoiceData?.email?.toString() || "",
            // gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            // pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            // pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            // gstPercetage: invoiceData?.gstPercentage?.toString() || "0",
            // id: invoiceData?.id?.toString() || "",
            // invoiceId: invoiceData?.invoiceId?.toString() || "",
            // isigst: invoiceData?.isigst ? "true" : "false",
            // items: formatItems(invoiceData?.items),
            // note: invoiceData?.note?.toString() || "",
            // paidFlagKey: invoiceData?.isPaid ? "true" : "false",
            // phone: invoiceData?.phone?.toString() || "",
            // totalAmount: invoiceData?.totalAmount?.toString() || "",
            // updateDate: invoiceData.creationDate?.toString() || new Date().getTime().toString(),
            // platform: "website",
            // version: 'website',
            companyId: invoiceData?.companyId?.toString() || "",
            creationDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            customInvoiceId: invoiceData?.customInvoiceId
                ? `SR-${invoiceData.customInvoiceId.toString()}`
                : "",

            customerId: invoiceData?.customerId?.toString(),
            date: invoiceData?.date?.toString() || "",
            discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            dueDate: invoiceData?.dateDue?.toString() || new Date().getTime().toString(),
            gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            gstPercetage: invoiceData?.gstPercentage?.toString() || invoiceData?.gstPercetage?.toString() || "0",
            id: invoiceData?.id?.toString() || "",
            invoiceId: invoiceData?.invoiceId?.toString() || "",
            isigst: invoiceData?.isigst || invoiceData?.igst == true ? "true" : "false",
            note: invoiceData?.note?.toString() || "",
            paidFlagKey: invoiceData?.isPaid ? "true" : "false",
            platform: "website",
            version: process.env.REACT_APP_VERSION,
            totalAmount: invoiceData?.totalAmount?.toString() || "",
            updateDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            items: formatItems(invoiceData?.items),
            reason: invoiceData?.reason?.toString() || "",
            isDeleted: false
        });
        const invoices = state?.INVOICES || [];


        const uniqueID = invoices?.find((invoice) => invoice?.invoiceId === invoiceData?.invoiceId)?.uniqueID;
        const originalItems = invoices?.find((invoice) => invoice?.invoiceId === invoiceData?.invoiceId)?.items || [];

        if (uniqueID && originalItems.length > 0) {
            const updatedItems = originalItems.map((item) => ({
                ...item,
                isSalesReturnKey: "true",
            }));

            const itemRef = ref(
                database,
                `invoiceGenerator/users/${ownerUid}/billInvoice/${uniqueID}/items`
            );

            // Firebase doesn't support full array update, so convert to object
            const itemsObject = {};
            updatedItems.forEach((item, index) => {
                itemsObject[index] = item;
            });

            await update(itemRef, itemsObject);
        }

        await AddItemDataInFirebase(state, dispatch, invoiceData?.items?.map(i => ({
            itemId: i?.itemId?.toString() || Date.now().toString(),
            name: i?.name?.toString() || "",
            price: i?.price?.toString() || "0.00",
            subtitle: i?.subtitle?.toString() || "",
            companyId: invoiceData?.companyId?.toString() || ""
        })), userId, false, ownerUid);

        // Fetch updated invoice data
        await GetSaleReturnDataFirebase(state, dispatch);

        return { success: true, message: "Return invoice added successfully!" };
    } catch (error) {
        return { success: false, message: error };
    }
};

export default AddAssignerUserSaleReturnDataInFirebase;
